import axios from '@/axios'
import vuecookie from "vue-cookies";
import { backendUrl } from '@/helpers/backendUrl.js'

const state = {
    invoicingActiveClients: [],
    invoicingReport: []
};

const getters = {
    getInvoicingActiveClients: (state) => state.invoicingActiveClients,
    getInvoicingReport: (state) => state.invoicingReport,
};

const actions = {
    async loadInvoicingActiveClients(context) {
        await axios().get(`/getInvoicingActiveClients`).then(response => {
            if (response.data.status) {
                context.dispatch('handleResponse', response, {root: true})
            }
            context.commit('setInvoicingActiveClients', response.data.activeClients)
        })
    },
    async loadInvoicingReport(context, data) {
        await axios().get(`/getInvoicingReport`, {
            params: {
                document_reference: data.document_reference,
                customer_reference: data.customer_reference,
                customer_name: data.customer_name,
                date_from: data.date_from,
                date_to:data.date_to,
                client: data.client,
                page: data.page,
                per_page: data.per_page,
            }
        }).then(response => {
            if (response.data.status) {
                context.dispatch('handleResponse', response, {root: true})
            }
            context.commit('setInvoicingReport', response.data.invoicingReport)
        })
    },
    async prepareInvoicingReportCsv( context, data ) {
        return await axios().post(`${backendUrl()}/prepareInvoicingReportCsv`, {
                documents: data.documents,
            }, {
                headers: { 'Authorization': "bearer " + vuecookie.get('token') }
            })
            .then(response => {
                return response.data
            })
    },
};

const mutations = {
    setInvoicingActiveClients: (state, invoicingActiveClients) => (state.invoicingActiveClients = invoicingActiveClients),
    setInvoicingReport: (state, invoicingReport) => (state.invoicingReport = invoicingReport),
};

export default {
    state,
    getters,
    actions,
    mutations
}
